import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { me, AdminUser } from "../lib/auth";

/**
 * Wrapper — pustí jen přihlášené. Jinak přesměruje na /admin/login.
 */
export default function RequireAuth({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  const [state, setState] = useState<"loading" | "ok" | "anon">("loading");
  const [, setUser] = useState<AdminUser | null>(null);

  useEffect(() => {
    me().then((u) => {
      if (u) {
        setUser(u);
        setState("ok");
      } else {
        setState("anon");
      }
    });
  }, []);

  if (state === "loading") {
    return (
      <div className="flex min-h-screen items-center justify-center text-slate-500">
        Načítám…
      </div>
    );
  }
  if (state === "anon") {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }
  return <>{children}</>;
}
